/**
 * Add 'js-go-back' class to any link/button to go back in history.
 * Done like this, because stage wysiwyg editors strip javascript
 * And this was wanted in hero component.
 *
 * Example usage (imported in master.js based on class name, but could be anything):
 *
 * <button class="js-go-back">Go back</button>
 */
class GoBack {
  constructor(element: HTMLElement) {
    element.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event: Event): void {
    event.preventDefault();
    window.history.go(-1);
  }
}

export function init(element: HTMLElement): void {
  console.log('go-back.init()');
  new GoBack(element);
}

export default GoBack;
